import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ErrorPanel(props) {
    return (_jsxs("div", { className: 'red-alert', children: [_jsx("h1", { children: props.title ?? 'Error' }), props.children && (_jsxs(_Fragment, { children: [_jsx("hr", {}), _jsx("pre", { children: props.children }), ' '] }))] }));
}
